import React from 'react';
import { Upgrade, Warning, CheckCircle } from '@mui/icons-material';

const MigrationGuide = () => {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center space-x-3 mb-4">
                <Upgrade className="text-amber-600 text-2xl" />
                <h3 className="text-xl font-semibold text-gray-900">Guide de Migration</h3>
            </div>

            <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                    <h4 className="font-medium text-blue-900 mb-2 flex items-center">
                        <CheckCircle className="text-blue-500 mr-2" />
                        v2.x → v3.x
                    </h4>
                    <ul className="text-blue-800 text-sm space-y-1">
                        <li>• API entièrement retravaillée</li>
                        <li>• Support TypeScript natif</li>
                        <li>• Meilleure gestion des erreurs</li>
                    </ul>
                </div>

                <div className="bg-amber-50 p-4 rounded-lg">
                    <h4 className="font-medium text-amber-900 mb-2 flex items-center">
                        <Warning className="text-amber-500 mr-2" />
                        Changements Cassants
                    </h4>
                    <ul className="text-amber-800 text-sm space-y-1">
                        <li>• Méthodes de paiement renommées</li>
                        <li>• Nouvelle structure de configuration</li>
                        <li>• Gestion des tokens modifiée</li>
                    </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-medium text-green-900 mb-2">Outils de Migration</h4>
                    <ul className="text-green-800 text-sm space-y-1">
                        <li>• Script de migration automatique</li>
                        <li>• Guide pas-à-pas disponible</li>
                        <li>• Support dédié pour la migration</li>
                    </ul>
                </div>
            </div>

            <button className="w-full mt-4 bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors">
                Voir le Guide Complet
            </button>
        </div>
    );
};

export default MigrationGuide;